/* eslint-disable no-unused-vars */
import { createAPIHandler } from "@/plugins/ofetch";
import downloadUrl from "@/utils/downloadUrl.js";

const _PaymentAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/payment.js").paymentReturn>}  */
  paymentReturn: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/payment/return`,
      { method: "GET", query }
    ]
  ),
};
export { _PaymentAPI as PaymentAPI };
const _SettingsAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/settings.js").getSettings>}  */
  getSettings: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/settings`,
      { method: "GET", query }
    ]
  ),
};
export { _SettingsAPI as SettingsAPI };
const _TaxReceiptsAPI = {
  /** @type {DownloadAPI<import("../../../../backend/api/public/tax-receipts.js").downloadTaxReceipt>}  */
  downloadTaxReceipt: function(uniqueId, query = undefined) {
    downloadUrl(`/n/api/public/tax-receipts/${encodeURIComponent(uniqueId)}`, query);
  },
};
export { _TaxReceiptsAPI as TaxReceiptsAPI };
